document.addEventListener("alpine:init", () => {
    Alpine.data("Schedule", () => ({
        open_job(job) {
            // make job available instantly on job view
            if (Alpine.store("schedule")) {
                Alpine.store("schedule").selected_job = job;
            }

            // route to schedule > job
            if (Alpine.store("state") && typeof Alpine.store("state").load === "function") {
                Alpine.store("state").load("schedule", "job", {booking_id: job.id});
            }
        },
    }));
});